import { render, staticRenderFns } from "./ComponentEdit.vue?vue&type=template&id=420182a0&"
import script from "./ComponentEdit.vue?vue&type=script&lang=js&"
export * from "./ComponentEdit.vue?vue&type=script&lang=js&"
import style0 from "./ComponentEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports